<header
  class="site-header"
  [class.dark-theam]="isDarkHeader"
  [class.arebic-content]="textDirection === 'rtl'"
>
  <div class="container">
    <nav>
      <div class="brand-logo cursor">
        <img
          routerLink="/"
          [src]="
            textDirection === 'rtl'
              ? isDarkHeader
                ? 'assets/images/partner-ar-logo.svg'
                : 'assets/images/taly-ar-logo.svg'
              : isDarkHeader
                ? 'assets/images/dark-logo-icon.svg'
                : 'assets/images/taly-dark-icon.svg'
          "
          alt="Brand-logo"
        />
      </div>
      <ul class="menu-list">
        @for (menu of heaerItems; track $index; let i = $index) {
          <!-- Normal menu item -->
          @if (!menu?.children) {
            <li
              (click)="navRedirection(menu, i)"
              [class.download]="menu?.type === 'download'"
              [class.active]="i === isActive"
              translate
              (keyup.enter)="navRedirection(menu, i)"
              tabindex="0"
              role="button"
            >
              {{ menu.label }}
            </li>
          } @else if (menu?.children?.length > 0) {
            <li
              translate
              class="main-menu"
              (mouseenter)="openOnHover(dropdownRef)"
              (mouseleave)="closeOnLeave(dropdownRef)"
            >
              <p-dropdown
                #dropdownRef
                [formControl]="menuCtrl"
                [options]="menu?.children"
                [optionLabel]="'link'"
                [optionValue]="'link'"
                (onShow)="dropdownOpen = true"
                (onHide)="dropdownOpen = false"
                (onBlur)="dropdownOpen = false"
              >
                <ng-template pTemplate="selectedItem">
                  <div class="flex align-items-center gap-2 sub-menu">
                    <div translate>SITE_HEADER.FOR_PARTNER</div>
                    <i
                      class="pi"
                      [ngClass]="{ 'pi-angle-down': !dropdownOpen, 'pi-angle-up': dropdownOpen }"
                    ></i>
                  </div>
                </ng-template>

                <ng-template let-item pTemplate="item">
                  <div
                    class="item-list"
                    [class.active]="menuCtrl?.value === item.link"
                    (click)="navRedirection(item, i)"
                    (keyup.enter)="navRedirection(item, i)"
                    tabindex="0"
                    role="button"
                  >
                    <div translate>{{ item.label }}</div>
                    <img src="assets/images/link-arrow.svg" alt="link" />
                  </div>
                </ng-template>
              </p-dropdown>
            </li>
          }
        }

        @if (heaerItems.length > 0) {
          <li
            class="is-grey"
            [ngClass]="{ hovered: isHovered }"
            (mouseenter)="isHovered = true"
            (mouseleave)="isHovered = false"
            (click)="toggleText()"
            (keyup.enter)="toggleText()"
            tabindex="0"
            role="button"
          >
            <div class="language">
              <img
                [src]="
                  textDirection === 'rtl'
                    ? 'assets/images/en-lang-logo.svg'
                    : 'assets/images/arebic-lang-icon.svg'
                "
                alt="lang-logo"
              />
              <label for="lang" class="language-name" translate>LANGUAGE</label>
            </div>
          </li>
        }

        @if (heaerItems.length > 0) {
          <li
            class="is-blue"
            [ngClass]="{ hovered: isHovered }"
            (mouseenter)="isHovered = true"
            (mouseleave)="isHovered = false"
            (click)="toggleText()"
            (keyup.enter)="toggleText()"
            tabindex="0"
            role="button"
          >
            <div class="language">
              <img
                [src]="
                  textDirection === 'rtl'
                    ? 'assets/images/en-lang-logo.svg'
                    : 'assets/images/arebic-lang-icon.svg'
                "
                alt="lang-logo"
              />
              <label for="lang" class="language-name" translate>LANGUAGE</label>
            </div>
          </li>
        }
      </ul>

      @if (isMenuOpen) {
        <ul class="menu-list-responsive">
          <div class="cros-icon">
            <img
              class="close-icon"
              src="assets/images/menu-close-icon.svg"
              (click)="isMenuOpen = false"
              (keyup.enter)="isMenuOpen = true"
              tabindex="0"
              role="button"
              alt="menu-icon"
            />
          </div>

          @for (menu of heaerItems; track $index; let i = $index) {
            @if (!menu?.children) {
              <li
                (click)="navRedirection(menu, i)"
                (keyup.enter)="navRedirection(menu, i)"
                tabindex="0"
                role="button"
                translate
                [class.active]="i === isActive"
              >
                {{ menu.label }}

                @if (!menu?.children) {
                  <i class="pi pi-angle-right"></i>
                }
              </li>
            } @else {
              <li translate="" [class.active]="i === isActive" class="last-child">
                <p-dropdown [options]="menu?.children">
                  <ng-template pTemplate="selectedItem">
                    <div class="dropdown-list">
                      <div translate>SITE_HEADER.FOR_PARTNER</div>
                      <i class="pi pi-angle-down"></i>
                    </div>
                  </ng-template>
                  <ng-template let-item pTemplate="item">
                    <div
                      class="flex align-items-center gap-2 item-list"
                      (click)="navRedirection(item, i)"
                      (keyup.enter)="navRedirection(item, i)"
                      tabindex="0"
                      role="button"
                    >
                      <div translate>{{ item.label }}</div>
                      <i class="pi pi-angle-right"></i>
                    </div>
                  </ng-template>
                </p-dropdown>
              </li>
            }
          }
        </ul>
      }

      <div
        class="language icon is-grey-mob"
        (click)="toggleText()"
        (keyup.enter)="toggleText()"
        tabindex="0"
        role="button"
      >
        <img
          [src]="
            textDirection === 'rtl'
              ? 'assets/images/en-lang-logo.svg'
              : 'assets/images/arebic-lang-icon.svg'
          "
          alt="lang-logo"
        />
        <label for="lang" translate>LANGUAGE</label>
      </div>

      <div
        class="language icon is-blue-mob"
        (click)="toggleText()"
        (keyup.enter)="toggleText()"
        tabindex="0"
        role="button"
      >
        <img
          [src]="
            textDirection === 'rtl'
              ? 'assets/images/en-lang-logo.svg'
              : 'assets/images/arebic-lang-icon.svg'
          "
          alt="lang-logo"
        />
        <label for="lang" translate>LANGUAGE</label>
      </div>

      <img
        class="menu-bar"
        (click)="isMenuOpen = true"
        (keyup.enter)="isMenuOpen = true"
        tabindex="0"
        role="button"
        [src]="isDarkHeader ? 'assets/images/dark-menu-bar.svg' : 'assets/images/menu-icon.svg'"
        alt="menu-icon"
      />
    </nav>
  </div>
</header>

<p-confirmDialog #cd>
  <ng-template pTemplate="header">
    <div>
      <h3 class="title" [innerHTML]="'APP.TITLE' | translate"></h3>
      <p class="desc" translate>APP.DESC</p>
    </div>
    <div
      class="qr-code-container"
      (click)="detectOS()"
      (keyup.enter)="detectOS()"
      tabindex="0"
      role="button"
      (keyup.enter)="detectOS()"
      tabindex="0"
      role="button"
    >
      <img class="qr-code" src="assets/images/new-qr.svg" alt="QR Code" />
    </div>
  </ng-template>
  <ng-template pTemplate="icon"> </ng-template>
  <ng-template pTemplate="message"> </ng-template>
  <ng-template pTemplate="footer">
    <button
      class="btn btn-sky-blue w-100"
      translate
      (click)="cd.reject()"
      (keyup.enter)="cd.reject()"
      tabindex="0"
      role="button"
    >
      BUTTON.CLOSE
    </button>
  </ng-template>
</p-confirmDialog>
